import React, { useEffect, useMemo, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

const NavBar = ({ user, onLogout, onOpenProfile }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const coreTabs = useMemo(
    () => [
      { to: "/", label: "Home" },
      { to: "/team", label: "Team" },
      { to: "/swimmers", label: "Swimmers" },
      { to: "/league", label: "League" },
    ],
    [],
  );

  const menuTabs = useMemo(() => {
    const items = [];
    items.push({ to: "/draft", label: "Draft" });
    if (process.env.NODE_ENV !== "production") {
      items.push({ to: "/dev/draft-preview", label: "Dev Draft" });
    }
    if (user?.isAdmin) {
      items.push({ to: "/admin", label: "Admin" });
    }
    return items;
  }, [user?.isAdmin]);

  return (
    <header className="nav-header">
      <div className="nav-top-row">
        <div className="nav-brand-wrap">
          <div className="brand">GB Gators</div>
          <div className="nav-brand-subtitle">Fantasy {currentYear}</div>
        </div>
        <div className="nav-top-actions">
          <button
            type="button"
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
            aria-pressed={menuOpen}
            onClick={() => setMenuOpen((prev) => !prev)}
            className="nav-menu-button"
          >
            ☰
          </button>
        </div>
      </div>

      <nav className="nav-links nav-core-links">
        {coreTabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.to === "/"}
            className={({ isActive }) =>
              isActive ? "nav-tab nav-tab-active" : "nav-tab"
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>

      <div className="nav-desktop-extras">
        {menuTabs.map((tab) => (
          <NavLink
            key={`desktop-${tab.to}`}
            to={tab.to}
            end={tab.to === "/"}
            className={({ isActive }) =>
              isActive ? "nav-tab nav-tab-active" : "nav-tab"
            }
          >
            {tab.label}
          </NavLink>
        ))}
        <button type="button" onClick={onLogout} className="nav-desktop-logout">
          Logout
        </button>
      </div>

      {menuOpen && (
        <div className="nav-menu-dropdown">
          {menuTabs.map((tab) => (
            <NavLink
              key={`mobile-${tab.to}`}
              to={tab.to}
              end={tab.to === "/"}
              className={({ isActive }) =>
                isActive
                  ? "nav-menu-link nav-menu-link-active"
                  : "nav-menu-link"
              }
              onClick={() => setMenuOpen(false)}
            >
              {tab.label}
            </NavLink>
          ))}
          <button
            type="button"
            className="nav-menu-link nav-menu-profile"
            onClick={() => {
              setMenuOpen(false);
              if (typeof onOpenProfile === "function") {
                onOpenProfile();
              }
            }}
          >
            Profile
          </button>
          <button
            type="button"
            onClick={() => {
              setMenuOpen(false);
              onLogout();
            }}
            className="nav-mobile-logout"
          >
            Logout
          </button>
        </div>
      )}
    </header>
  );
};

export default NavBar;
